export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "shares",
      layout: "dashboard",
    },
    path: "/shares",
    name: "shares",
    component: () => import("@/layouts/index/ShareIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste de clients",
          layout: "dashboard",
        },
        path: "index",
        name: "shares-index",
        component: () => import("@/views/shares/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un compte clientèle",
          layout: "dashboard",
        },
        path: "create",
        name: "shares-create",
        component: () => import("@/views/shares/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier le compte clientèle",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "shares-edit",
        component: () => import("@/views/shares/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Details de compte clientèle",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "shares-details",
        component: () => import("@/views/shares/Details.vue"),
      },
    ],
  },
];
